import { render, staticRenderFns } from "./TwStatusIcon.vue?vue&type=template&id=744007e7&scoped=true&"
import script from "./TwStatusIcon.vue?vue&type=script&lang=js&"
export * from "./TwStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./TwStatusIcon.vue?vue&type=style&index=0&id=744007e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744007e7",
  null
  
)

export default component.exports